<template>
  <div class="content-container gradient-animation">
    <title-with-breadcrumbs title="Cart"></title-with-breadcrumbs>
    <div class="flex mt-regular">
      <div class="cart-container">
        <cart></cart>
      </div>
      <div class="price-container">
        <div class="sticky">
          <price-breakdown></price-breakdown>
          <div class="btn-container">
            <button class="button salmon" @click="checkoutClicked">
              Go to checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  updateCart as updateRemoteCart,
  getCart as getRemoteCart,
  createCart as createRemoteCart
} from "../services/api";
import Cart from "../components/organisms/cart";
import { cartMethods } from "../mixins";
import PriceBreakdown from "../components/molecules/price-breakdown.vue";
import TitleWithBreadcrumbs from "../components/atoms/title-with-breadcrumbs.vue";
export default {
  name: "CartPage",
  components: { Cart, PriceBreakdown, TitleWithBreadcrumbs },
  mixins: [cartMethods],
  methods: {
    async getCart() {
      const cartId = this.$route.params.id;
      if (cartId) {
        await this.overwriteLocalCart(cartId);
      } else if (this.cart) {
        if (this.cart.cart_id) {
          await this.updateCart();
        } else if (this.cart.products && this.cart.products.length) {
          await this.createCart();
        }
      }
    },
    async overwriteLocalCart(cartId) {
      const result = await getRemoteCart(cartId);
      if (result.status == 200) {
        const serverCart = result.data;
        this.setCart(serverCart);
      }
      return result;
    },
    async updateCart() {
      const result = await updateRemoteCart(this.cart);
      const errorStatus = result.response && result.response.status;
      if (errorStatus == 404 || errorStatus == 500) {
        // console.log("Couldn't update cart");
        // this.setCart({ ...this.cart, cart_id: null });
        // await this.getCart();
      } else if (errorStatus == 400) {
        const reason = result.response.data.message;
        if (reason.includes("expired")) {
          this.cart.status = "Expired";
        }
        if (reason.includes("closed")) {
          this.setLocalCart({ products: [] });
        }
        // console.log(result.response.data.message);
        //await this.createCart();
      } else {
        this.setCart(result.data);
      }
    },
    async createCart() {
      const result = await createRemoteCart(this.cart);
      if (result.status == 201) {
        const serverCart = result.data;
        this.setCart(serverCart);
      }
    },
    checkoutClicked(event) {
      event && event.preventDefault();
      this.$router.push({ name: "CheckoutPage" });
    },
    ...mapMutations({
      setLocalCart: "cart/setCart",
      updateLocalCart: "cart/setCart"
    })
  },
  beforeMount() {
    this.getCart();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.content-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.flex {
  flex-direction: column;
}

.price-container {
  display: flex;
  flex-direction: column;
}

.sticky {
  position: sticky;
  top: 2rem;
}

.button {
  box-shadow: none;
}

.btn-container {
  padding: 1rem;
  background-color: $brand-white;

  .button {
    width: 100%;
  }
}

@media (min-width: $breakpoint-md) {
  .flex {
    flex-direction: row;
  }
  .cart-container {
    width: 55%;
  }

  .price-container {
    width: 45%;
    padding-left: 2rem;
  }
}

@media (min-width: $breakpoint-lg) {
  .price-container {
    padding-left: 5rem;
  }
}
</style>
